export default {
      id: "video-usage",
      viewBox: "0 0 36 25",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#video",
      toString: function () {
        return this.url;
      }
    }